<!-- HubModal.vue -->
<template>
  <div class="modal-container">
    <img
      src="images/close.svg"
      class="close"
      @click="resetModal"
      role="button"
      aria-label="Close"
      alt="X to close modal"
      title="Close"
    />
    <div class="modal-content">
      <div class="modal-main">
        <template v-for="(groupItems, group) in computedItems" :key="group">
          <div class="centered-text">
            <h2>{{ group }}</h2>
          </div>
          <div class="modal-grid">
            <a
              class="modal-cell"
              v-for="(item, index) in groupItems"
              :key="index"
              target="_blank"
            >
              <div
                class="image-container"
                :class="{ inactive: item.inactive }"
                v-html="item.svg"
                @click="setModal(item)"
              ></div>
              <div class="modal-title">
                {{ item.name }}
              </div>
            </a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HubModal",
  props: {
    resetModal: {
      type: Function,
      required: true,
    },
    items: {
      type: Object,
      required: true,
    },
    puzzleCompleted: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {
    computedItems() {
      return Object.fromEntries(
        Object.entries(this.items).map(([key, arr]) => [
          key,
          arr.map((obj) => ({
            ...obj,
            inactive: obj.name === "Benchmarks" && !this.puzzleCompleted,
          })),
        ])
      );
    },
  },
  methods: {
    setModal(item) {
      if (!item.inactive) {
        this.$emit("set-modal", ...item.modal);
      }
    },
  },
};
</script>

<style scoped>
* {
  --button-text-color: var(--border-color);
}
.inactive {
  color: var(--disabled) !important;
  --button-text-color: var(--disabled) !important;
}
.inactive {
  cursor: default !important;
}
h2,
h3 {
  text-align: center;
}
.page-icon {
  height: 5vh;
}
.modal-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1vh;
  justify-content: center;
  margin: 2vh 0;
}
.modal-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  /* flex: 0 0 21%; */
  width: 100px;
  flex-direction: column;
  gap: 0.5vh;
  aspect-ratio: 1 / 1;
}
.modal-cell .image-container {
  /* border-radius: 50%; */
  width: 65%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  /* border: 1px solid rgba(0, 0, 0, 0.185); */
  display: flex;
  cursor: pointer;
}

.modal-cell .modal-title {
  height: 5vh;
  display: flex;
  text-align: center;
}

.image-container img {
  width: 60%;
  display: block;
  margin: auto;
}

.modal-cell,
.modal-cell:hover,
.modal-cell:visited {
  text-decoration: none;
  color: var(--text-color);
}
.modal-main {
  overflow-y: auto;
  overflow-x: hidden;;
}
</style>